import { ROUTES } from "@/routes/routes.config";
import type { HeaderProps } from "./Header.types";
import { buildDashboardTabUrl } from "@/hooks/useBuildWithParams";
import { DASHBOARD_TABS } from "@/constants/dashboardTabs";

export const headerConfig: HeaderProps = {
    logo: {
        src: "/images/logo.svg",
        alt: "Defy Medical"
    },
    navItems: [
        { id: 'trimix', label: 'Trimix', to: '/trimix', active: false },
        { id: 'oral-meds', label: 'Oral Meds', to: '/oral-meds', active: false },
        { id: 'about', label: 'About Defy ED', to: '/about-us', active: false },
        { id: 'contact', label: 'Contact', to: '/contact-us', active: false }
    ],
    icons: [
        {
            id: 'user',
            iconSrc: "/images/icons/icon-user.svg",
            ariaLabel: 'User Account',
            onClick: () => { },
        },
        {
            id: 'cart',
            iconSrc: "/images/icons/icon-cart.svg",
            ariaLabel: 'Shopping Cart',
            badgeCount: 0,
            isBadgeCountLoading: false
        },
        {
            id: "login",
            iconClassName: "bi bi-box-arrow-in-right",
            ariaLabel: "Login",
            onClick: () => { },
        },
        {
            id: "logout",
            iconClassName: "bi bi-box-arrow-right",
            ariaLabel: "Logout",
            onClick: () => { },
        },
    ],
    ctaButton: {
        text: 'Get Started',
        afterUpdateProfileText: 'Take Questionnaire',
        to: ROUTES.QUESTIONNAIRES,
        afterRegisterText: 'Update Profile',
        afterRegisterRedirection: buildDashboardTabUrl(DASHBOARD_TABS.UPDATE),
        className: ''
    },
    mobileMenuLinks: [
        // { id: 'privacy', label: 'Privacy Policy', to: '/privacy', className: 'mb-2' },
        // { id: 'terms', label: 'Terms of Service', to: '/terms', className: 'mb-2' }
    ]
};
